import React from 'react';
import type {
  FileLocalUrl,
} from 'pages/Dashboard/components/FilePicker';
import FilerobotEditor from 'views/EMR/components/ImageEditorDialog/FilerobotEditor';

export type ImageEditorDialogProps = {
  src: string;
  fileName?: string;
  onSave: (file: FileLocalUrl) => Promise<void> | void;
};

type Props = ImageEditorDialogProps & {
  onClose: () => void;
};

export default function ImageEditorDialog(props: Props) {
  return <FilerobotEditor {...props} />;
}
